import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AuthFlowDialog from './AuthFlowDialog';
import { buyCDK } from '../../actions/userActions';
import './BuyCDK.scss';

class BuyCDK extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      productData: null,
      isLoading: true,
      showAuthDialog: false,
    };
  }

  componentDidMount() {
    // 从路由参数获取产品ID
    const { productId } = this.props.params || {};
    
    // Mock 数据，实际应该从 API 获取
    const mockProduct = {
      id: productId || 'cdk20251211001',
      name: 'Bellwright SteamCDK',
      image: '/study-bellwright.jpg',
      price: 190,
      currency: 'USDO',
      stock: 690,
      description: 'Bellwright is a deep and complex strategy game in a living medieval world.',
    };

    this.setState({
      productData: mockProduct,
      isLoading: false,
    });
  }

  handleBuyNow = () => {
    console.log('handleBuyNow clicked');
    // 无论是否登录，都显示对话框
    // 如果已登录，显示账户选择页面；如果未登录，显示登录页面
    console.log('Setting showAuthDialog to true');
    this.setState({ showAuthDialog: true }, () => {
      console.log('showAuthDialog state updated:', this.state.showAuthDialog);
    });
  }

  handleAuthDialogClose = () => {
    this.setState({ showAuthDialog: false });
  }


  handleWalletConnected = (walletType) => {
    // 钱包连接完成（注册流程），执行购买
    this.setState({ showAuthDialog: false });
    this.executePurchase();
  }

  executePurchase = () => {
    const { auth, productData } = this.props;
    const { productData: stateProductData } = this.state;
    
    if (!auth || !auth.token) {
      return;
    }

    // 执行购买逻辑
    const product = stateProductData || productData;
    if (product && this.props.buyCDK) {
      // 使用钱包支付（noiz）
      this.props.buyCDK(
        product.id,
        product.price,
        1, // amount
        'noiz', // payType
        'b', // purchaseType: 'b' for buy, 'g' for gift
        '', // doneeEmail
        auth.token
      );
    }
  }

  closeModal = () => {
    // 返回上一页或关闭
    window.history.back();
  }

  render() {
    const { productData, isLoading } = this.state;

    if (isLoading) {
      return (
        <div className="buy-cdk-container">
          <div className="loading">
            <i className="fa fa-spinner fa-spin fa-3x" />
          </div>
        </div>
      );
    }

    if (!productData) {
      return (
        <div className="buy-cdk-container">
          <div className="error">Product not found</div>
        </div>
      );
    }

    return (
      <div className="buy-cdk-container">
        <div className="buy-cdk-modal">
          <div className="modal-header">
            <div className="header-left">
              <i className="fa fa-shopping-cart" />
              <span>Buy CDK</span>
            </div>
            <button className="close-btn" onClick={this.closeModal}>
              <i className="fa fa-times" />
            </button>
          </div>

          <div className="modal-content">
            <div className="product-section">
              <div className="product-image">
                <img src={productData.image} alt={productData.name} />
              </div>
              
              <div className="product-info">
                <h2 className="product-name">{productData.name}</h2>
                <div className="product-stock">
                  Quantity: <span className="stock-value">{productData.stock}</span> (Stock: {productData.stock})
                </div>
                
                <div className="product-pricing">
                  <div className="price-label">Price</div>
                  <div className="price-value">
                    <span className="amount">{productData.price}</span>
                    <span className="currency">{productData.currency}</span>
                  </div>
                </div>

                <div className="payment-methods">
                  <div className="payment-label">Payment methods</div>
                  <button className="payment-btn">
                    <i className="fa fa-dollar" />
                    <span>USDO</span>
                  </button>
                </div>

                <button 
                  className="buy-now-btn" 
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.handleBuyNow();
                  }}
                >
                  Buy now and get CDK
                </button>

                <div className="transaction-info">
                  <div className="info-item">
                    <i className="fa fa-shield" />
                    <span>Secure transaction</span>
                  </div>
                  <div className="info-item">
                    <i className="fa fa-bolt" />
                    <span>Instant issuance</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="purchase-process">
              <div className="process-header">
                <i className="fa fa-info-circle" />
                <span>Purchase process</span>
              </div>
              
              <div className="process-steps">
                <div className="step">
                  <div className="step-icon">
                    <i className="fa fa-link" />
                  </div>
                  <div className="step-content">
                    <div className="step-title">1. Connect your wallet</div>
                    <div className="step-desc">Connect your digital currency wallet to make the transaction</div>
                  </div>
                </div>

                <div className="step">
                  <div className="step-icon">
                    <i className="fa fa-credit-card" />
                  </div>
                  <div className="step-content">
                    <div className="step-title">2. Confirm payment</div>
                    <div className="step-desc">Confirm transaction details and authorize payment</div>
                  </div>
                </div>

                <div className="step">
                  <div className="step-icon">
                    <i className="fa fa-download" />
                  </div>
                  <div className="step-content">
                    <div className="step-title">3. Obtain CDK</div>
                    <div className="step-desc">Automatically display and download the CDK, and start using it now</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 认证流程对话框 */}
        <AuthFlowDialog
          open={this.state.showAuthDialog} 
          onClose={this.handleAuthDialogClose}
          onWalletConnected={this.handleWalletConnected}
          initialStep={this.props.auth && this.props.auth.token && this.props.auth.user ? 'accountConfirm' : 'login'}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  buyCDK,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BuyCDK);
